<main>
	<article
		class="bg-surface-100-800-token my-4 mx-4 pt-4 rounded-lg shadow-xl border border-slate-500"
	>
		<slot />
	</article>
</main>

<style>
	main {
		max-width: 1000px;
		margin-left: auto;
		margin-right: auto;
	}
</style>
